import React, { useRef } from 'react';
import configJson from '../../Config.json';
import MenuTemplate from './menu-template';

const Nav = (props) => {
    const menuRef = useRef(null);

    if (props != null && props.menu != null && props.menu.length > 0) {
        let topMenu = props.menu
            .filter(x => x.MenuGroupName === "GOCreative_Top")
            .map(x => x.MenuList)
            .filter(x => x != null);

        let subTopMenu = props.menu
            .filter(x => x.MenuGroupName === "GOCreative_TopNext")
            .map(x => x.MenuList)
            .filter(x => x != null);

        return (
            <div async>
                <div className="nav__wrapper" ref={menuRef}>
                    <div className="container menu__container">
                        <div className="header_container">
                            <header id="header">
                                <h1 className="visuallyhidden">{props.h1Tag}</h1>
                                <a rel="noopener noreferrer" id="skiptocontent" href="#header">Skip to Content</a>

                                <div className="section1">
                                    <div id="logo_container">
                                        <div id="logo">
                                            <a rel="noopener noreferrer" href={"/"}><img src={configJson.S3ImageURL + "/static/Images/rrd_logo.svg"} alt="Go Creative Home Page" loading='lazy' /></a>
                                        </div>
                                        <h2 className="visually-hidden">Mobile Menu</h2>
                                        <h3>Menu</h3>
                                        <div className="mobile_menu_container">
                                            <div className="mobile_menu">
                                                <a rel="noopener noreferrer" id="menu-toggle" className="menu-toggle" aria-label="Open the menu" href="#">
                                                    <img src='/assets/img/menu.svg' role='button' alt='Open' />
                                                </a>
                                            </div>
                                            <div className="mobile_menu_close" >
                                                <a rel="noopener noreferrer" id="mobile_closebtn" href="#">
                                                    <img src={configJson.S3ImageURL + "/static/Images/close.svg"} role='button' alt="mobile close menu" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <MenuTemplate menu={topMenu} subTopMenu={subTopMenu} menuRef={menuRef} resources={props.resources} />
                                </div>
                            </header>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    return null;
}
export default Nav;